(function() {
    UserGrid.$inject = ['$scope', '$http', '$location', '__env', 'toastr', 'httpService', 'readCookie', '$log'];

    angular
    	.module('app')
    	.component('userGridComponent', {
    		templateUrl: 'modules/users/components/userGrid/userGrid.html',
    		controller: UserGrid
    	});

    /**
     * Constructor for userPortalController
     *
     * @class userPortalController
     * @param { Object } $scope - The scope of the controller.
     * @param { Object } $http - The Angular $http service.
     * @param { Object } $location - The Angular $location service.
     * @param { Object } __env - The environment configuration.
     * @param { Array } auth - The resolved response from the auth check in the module.
     * @param { Array } permissionPermissions - The The resolved response from the permission check in the module.
     * @param { Object } toastr - The third party toaster service.
     * @param { Object } httpService - The service to send http calls.
     * @param { service } $log - The service to log to console (or to file if needed)
     */
    function UserGrid($scope, $http, $location, __env, toastr, httpService, readCookie, $log){
    	///////////////////////////////////////////////////////////////////////////
    	// Members
    	///////////////////////////////////////////////////////////////////////////

    	$scope.permissionChecks = {};
    	$scope.pagePermissions = {};
        $scope.permissionPermissions = {};

    	$scope.pageTitle = 'User Management';
    	$scope.modalEmail = '';

        var permissionPerms = $scope.$parent.$ctrl.permissionPermissions;

        // rewrite permission permissions to be easily checked
        for (var i = 0; i < permissionPerms.length; i++){
            $scope.permissionPermissions[permissionPerms[i]] = true;
        }

        var perms = $scope.$parent.$ctrl.permissions.data;

    	// rewrite the permissions array to be easily checked
    	for (var i = 0; i < perms.length; i++){
    		$scope.pagePermissions[perms[i]] = true;
    	}

    	// USER GRID SETUP ---------------------------------------------------------------//
    	// column properties for the user grid
    	var columns = [
    	        {
    	            field: 'email',
    	            title: 'Email',
    	            width: '100px',
    	        },
    	        {
    	        	field: 'isEmailConfirmed',
    	        	title: 'Email Confirmed',
    	        	width: '35px',
    	        	attributes:{ class:'center' },
                    groupable: false,
                    filterable: false,
                    template: '<input type="checkbox" ng-checked="#=isEmailConfirmed#" ng-disabled="displayMode" />'
    	        },
    	        {
    	        	field: 'lastPasswordChangeDate',
    	        	title: 'Last Password Change',
    	        	width: '50px',
    	        	template: '#= lastPasswordChangeDate != null ? kendo.toString(kendo.parseDate(lastPasswordChangeDate), "yyyy-MM-dd") : ""#'
    	        },
    	        {
    	        	field: 'mustChangePassword',
    	        	title: 'Force Password Change',
    	        	width: '30px',
    	        	attributes:{ class:'center' },
                    groupable: false,
                    filterable: false,
                    template: '<input type="checkbox" ng-checked="#=mustChangePassword#" ng-disabled="displayMode" />'
    	        },
    	        {
    	        	field: 'isLockoutEnabled',
    	        	title: 'Allow Lock Out',
    	        	width: '30px',
    	        	attributes:{ class:'center' },
                    groupable: false,
                    filterable: false,
                    template: '<input type="checkbox" ng-checked="#=isLockoutEnabled#" ng-disabled="displayMode" />'
    	        },
    	        {
    	        	field: 'lockoutEndDateUtc',
    	        	title: 'Locked Until (UTC)',
    	        	width: '45px',
    	        	format: '{0:yyyy-MM-dd h:mm tt}',
    	        	template: '#= lockoutEndDateUtc != null ? kendo.toString(kendo.parseDate(lockoutEndDateUtc), "yyyy-MM-dd h:mm tt") : ""#'
    	        },
    	        {
    	        	field: 'deactivated',
					title: 'User Status',
					attributes:{ class:'center' },
    	        	width: '40px',
    	        	template: '#= deactivated ? "Deactivated" : "Active"#'
    	        }
    	    ];

    	// create the edit column
        column = {
        	command: [],
        	title: '&nbsp;',
        	width: '100px'
        };

        // if the user can read permissions, add permissions to the command
        if($scope.permissionPermissions.read || $scope.permissionPermissions.write){
        	column.command.push({
    			template: '<button class="k-button" type="button" ng-click="showPermissions(this)">Permissions</button>'
    		});
        }

        if($scope.pagePermissions.write){
        	column.command.push('edit');
        	column.command.push('destroy');
        }

        if(column.command.length > 0) {
        	columns.push(column);
        }

        // model kendo uses to bind the data to the grid
		var model = {
			id: 'userId',
			fields: {
				'selectUsers': { editable: false },
				'email': { type: 'string' },
				'active': { type: 'boolean' },
				'isEmailConfirmed': { type: 'boolean' },
				'lastPasswordChangeDate': { type: 'date', editable: false },
				'mustChangePassword': { type: 'boolean', defaultValue: true },
				'isLockoutEnabled': { type: 'boolean', defaultValue: true },
				'lockoutEndDateUtc': { type: 'date', defaultValue: '' },
				'deactivated' : { type: 'boolean', defaultValue: false }
			}
		};

        // kendo data source for the User Grid
    	$scope.userSource = {
    		type: 'aspnetmvc-ajax',
            error: readError,
    		transport: {
    			read: {
    				type: 'get',
    				contentType: 'application/json',
    				url: __env.apiBaseUrlUser  + 'users/paged/kendo',
    				beforeSend: function(req) {
    		           req.setRequestHeader('UserToken', readCookie.getByName(__env.sessionCookieName));
					   req.setRequestHeader('Authorization','Bearer ' + readCookie.getByName(__env.authCookieName));
					},
    			},
    		},
    		schema: {
                data: 'data',
                total: 'total',
                model: model,
            },
            pageSize: 20,
            serverPaging: true,
            serverSorting: true,
            serverFiltering: true,
            sort: {
                field: 'email',
                dir: 'asc'
            }
    	};

    	// kendo grid options for the User grid
        $scope.userOptions = {
        	cancel: function(e){ $scope.displayMode = true; },
            columnMenu: false,
            columns: columns,
            detailInit: function(e){ $scope.detailInit(e); },
            edit: function(e){ $scope.editUser(e); },
			editable: {
				mode: 'popup',
				template: kendo.template($('#userEdit').html())
			},
            filterable: {
                extra: false,
                operators: {
                    string: {
                        contains: 'Contains',
                        eq: 'Is equal to'
                    }
                }
            },
            groupable: false,
            pageable: true,
            remove: deleteEvent,
            save: saveEvent,
            scrollable: true,
            selectable: 'multiple',
            sortable: true
        };
        // END USER GRID SETUP -------------------------------------------------------------//

        // PORTAL GRID SETUP ---------------------------------------------------------------//
        // columns for the portal table
		var portalColumns = [
			{
				field: 'portalName',
				title: 'Portal Name',
				editable: false,
				width: 75
			},
			{
				field: 'baseUri',
				title: 'Portal URI',
				editable: false,
				width: 75
			},
			{
				field: 'homePageRelativeUri',
				title: 'Relative URI',
				editable: false,
				width: 75
			}
		];

        if($scope.pagePermissions.write) {
			portalColumns.push(
				{
					command: [{ name: 'destroy', text: 'Remove' }],
					title: '&nbsp;',
					width: 45
				});
        }

		var portalModel = {
			id: 'portalid',
			fields: {
				'portalName': { type: 'string' },
				'baseUri': { type: 'string' },
				'homePageRelativeUri': { type: 'string' }
			}
		};

        $scope.isPermissionVisible = false;
        $scope.displayMode = true;

        // kendo multiselect options for the portal dropdown
        $scope.portalSearchOptions = {
    		placeholder: 'Select Portals...',
            dataTextField: 'portalName',
            dataValueField: 'portalId',
            valuePrimitive: true,
            autoBind: false,
            dataSource: {
                type: 'aspnetmvc-ajax',
                serverFiltering: true,
                transport: {
                    read: {
                        type: 'get',
                        contentType: 'application/json',
                        url: __env.apiBaseUrlPortal  + 'portals/paged/kendo',
    					beforeSend: function(req) {
    			           req.setRequestHeader('UserToken', readCookie.getByName(__env.sessionCookieName));
						   req.setRequestHeader('Authorization','Bearer ' + readCookie.getByName(__env.authCookieName));
						}
                    }
                },
                schema: {
                    data: 'data',
                    total: 'total'
                },
                sort: {
                    field: 'portalName',
                    dir: 'asc'
                }
            }
    	};

    	// END PORTAL GRID SETUP ---------------------------------------------------------------//

        if($scope.pagePermissions.write) {
        	$scope.userOptions.toolbar = [
           		{ template: kendo.template($('#portalSearch').html()) }
       		];
        }

        ///////////////////////////////////////////////////////////////////////////
    	// Functions
    	///////////////////////////////////////////////////////////////////////////

    	/**
         * handles delete event for the user grid.
         *
         * @function
         * @param { event } e - delete row event
         */
		function deleteEvent(e) {
			e.preventDefault();
			if (confirm('Are you sure you want to delete the user?')) {
				$scope.deleteUser(e.model.userId);
			} else {
				$scope.userGrid.dataSource.read();
			}
    	}

    	/**
         * handles delete event for the portal grid.
         *
         * @function
         * @param { event } e - delete portal event
         */
    	function deletePortalEvent(e) {
    		e.preventDefault();

    		$scope.deletePortal(e.model, e);
    	}

    	$scope.editUser = function(e) {
    		$scope.displayMode = false;
    		e.model.lockoutEndDateUtc = null;
    	};

    	/**
         * handles read error event for the user grid.
         *
         * @function
         * @param { event } e - read error event
         */
    	function readError(e) {
    		toastr.error('Something went wrong with the read request');
    	}

    	/**
         * handles save event for the user grid.
         *
         * @function
         * @param { event } e - save row event
         */
    	function saveEvent(e) {

    		$scope.displayMode = true;

    		// stop kendo from being annoying
    		e.preventDefault();

    		if(e.model.userId > 0) {

    			// users with an id should be updated
    			$scope.updateUser(e.model);
    		} else {
    			e.model.userId = 0;

    			// users without an id should be added
    			$scope.addUser(e.model);
    		}
    	}

    	$scope.addNewUser = function() {
    		$scope.userGrid.addRow();
    	};

    	/**
         * Prepares the http request for updating adding a group of portals
         * to a group of users. Handles callbacks.
         *
         * @function
         */
        $scope.addPortalsToUsers = function() {
        	// get selected rows
        	var rows = $scope.userGrid.select();

        	var users = [];

        	// loop through and put the ids in an array
        	for (var i = 0; i < rows.length; i++) {

        		users.push($scope.userGrid.dataItem(rows[i]).userId);
        	}

        	var data = {'userIds': users, 'portalIds': $scope.portalIds };
        	var type = 'post';
        	var url = __env.apiBaseUrlUser  + 'userportals/';

        	httpService.asyncCall(url, type, data)
    			.then(function(response) {
    				toastr.success('Portals have been added for selected users');
    				$scope.userGrid.dataSource.read();
    			}).catch(function(e){
    				toastr.error('The portals could not be added for the requested users');
                     var message = 'Status: ' + e.status +
                                    '; Error:' + e.statusText;


                    $log.error(message);
    				$scope.userGrid.dataSource.read();
    			});

            $scope.portalIds = [];
        };

    	/**
         * Prepares the http request for adding a new user.
         *
         * @function
         * @param { obj } user - user object to be added
         */
    	$scope.addUser = function(user) {
            var url = __env.apiBaseUrlUser  + 'users/';
    		var type = 'post';
    		var data = user;

    		httpService.asyncCall(url, type, data)
    			.then(function(response) {
    				toastr.success('User successfully added');
    				$scope.userGrid.dataSource.read();
    			}).catch(function(e){
    				toastr.error('The User could not be added');
                     var message = 'Status: ' + e.status +
                                    '; Error:' + e.statusText;


                    $log.error(message);
    				$scope.userGrid.dataSource.read();
    			});
        };

    	/**
         * Prepares the http request for deleting a user. Handles callbacks
         *
         * @function
         * @param { int } userId - id of user to be deleted
         */
        $scope.deleteUser = function(userId) {
        	var url = __env.apiBaseUrlUser  + 'users/' + userId;
    		var type = 'delete';
    		var data = '';

    		httpService.asyncCall(url, type, data)
    			.then(function(response) {
    				toastr.success('User successfully deleted');
    				$scope.userGrid.dataSource.read();
    			}).catch(function(e){
    				toastr.error('The User could not be deleted');
                     var message = 'Status: ' + e.status +
                                    '; Error:' + e.statusText;


                    $log.error(message);
    				$scope.userGrid.dataSource.read();
    			});
    	};

    	/**
         * Prepares the http request for removing a portal from a user.
         *
         * @function
         * @param { obj } portal - portal to be deleted
         * @param { event } e - kendo remove button click event
         */
        $scope.deletePortal = function(portal, e) {
        	// get the master row for the detail
        	var parentRow = e.row.closest('.k-detail-row').prev();

        	// get the coresponding user
        	var user = $scope.userGrid.dataItem(parentRow);

        	// find the grid so that the datasource can be refreshed
        	var grid = $('#portal-' + user.uid).data('kendoGrid');

        	// get the data to be sent
        	var data = {'portalTokens': [portal.portalToken]};

        	var url = __env.apiBaseUrlUser  + 'userportals/' + encodeURI(user.email) + '/portals';
    		var type = 'delete';
    		var data = data;

    		httpService.asyncCall(url, type, data)
    			.then(function(response) {
    				toastr.success('Portal successfully removed from user');
    				grid.dataSource.read();
    			}).catch(function(e){
    				toastr.error('The portal could not be removed');
                     var message = 'Status: ' + e.status +
                                    '; Error:' + e.statusText;

                    $log.error(message);
    				grid.dataSource.read();
    			});
    	};

    	/**
         * Inner grid displaying portals that users belong to on click.
         *
         * @function
         * @param { event } e - open grid row event
         */
        $scope.detailInit = function(e) {
        	$('<div id="portal-' + e.data.uid + '"/>').appendTo(e.detailCell).kendoGrid({
        		//error: function(e) {debugger;},
        		dataSource: {
        			type: 'aspnetmvc-ajax',
    				transport: {
    					read: {
    						type: 'get',
    						contentType: 'application/json',
    						beforeSend: function(req) {
								req.setRequestHeader('UserToken', readCookie.getByName(__env.sessionCookieName));
								req.setRequestHeader('Authorization','Bearer ' + readCookie.getByName(__env.authCookieName));
    				       	},
    						url: __env.apiBaseUrlUser  + 'userportals/' + e.data.id + '/paged/portals'
    					},
    				},
    				schema: {
    		            data: 'data',
    		            total: 'total',
    		            model: portalModel
    		        },
    		        pageSize: 20,
    		        serverPaging: true,
    		        serverSorting: true,
    		        serverFiltering: true,
    		        sort: {
    		            field: 'portalName',
    		            dir: 'asc'
    		        }
    			},
    	        columns: portalColumns,
    	        editable: true,
    	        filterable: {
    	            extra: false,
    	            operators: {
    	                string: {
    	                    contains: 'Contains',
    	                    eq: 'Is equal to'
    	                }
    	            }
    	        },
    	        groupable: false,
    	        remove: deletePortalEvent,
    	        pageable: true,
    	        scrollable: true,
    	        sortable: true
        	});
        };

        /**
         * gets a list of all permissions up front to populate permission modal
         *
         * @function
         */
    	$scope.getPermissions = function() {
    		var url = __env.apiPermissions;
    		var type = 'get';
    		var data = '';

            httpService.asyncCall(url, type, data)
    			.then(function(response) {
    				$scope.permissions = response.data;
    			}).catch(function(e){
    				toastr.error('Could not retrieve permission list');
					var message = 'Status: ' + e.status +
						'; Error:' + e.statusText;

                    $log.error(message);
    			});
    	};

        /**
    	 * Binds the kendo selected values to the checkbox
    	 * @function
    	 * e {event} - click event for the checkbox
    	 */
		$scope.selectUsers = function (e) {
			var grid = $scope.userGrid;

			var element = $(e.currentTarget);

			var checked = element.is(':checked'),
			row = element.closest('tr'),
				dataItem = grid.dataItem(row);

			if (checked) {
				row.addClass('k-state-selected');
			} else {
				row.removeClass('k-state-selected');
			}
		};

         /**
         * Prepares the http request for setting or removing permission for a user.
         * On success
         *
         * @function
         * @param { event } e - checkbox click event
         * @param { element } checkbox - checkbox that was clicked
         */
        $scope.setPermission = function(e, checkbox) {

        	var permissionId = checkbox.permission.permissionId;
        	var permissionDisplayName = checkbox.permission.permissionDisplayName;

        	var email = $scope.modalEmail.replace('+', ' ');
        	var url = __env.apiUserPermissions + '/user/' + encodeURI(email) + '/permission/' + permissionId;
        	var data = '';

        	if(this.permissionChecks[permissionDisplayName]) {
                var type = 'put';
        	} else {
        		var type = 'delete';
        	}

			httpService.asyncCall(url, type, data)
				.then(function (response) {

				}).catch(function (e) {
					toastr.error('Permission was not updated');
					var message = 'Status: ' + e.status +
						'; Error:' + e.statusText;

					$log.error(message);
					$scope.userGrid.dataSource.read();
				});
        };

        /**
         * Prepares the http request for getting permission for a user.
         * On success, sets the permission checkboxes
         *
         * @function
         * @param { element } button - button that fired the click event
         */
        $scope.showPermissions = function(button) {
        	$scope.modalEmail = button.dataItem.email;

        	$scope.permissionChecks = {};
        	var email = $scope.modalEmail.replace('+', ' ');

            var url = __env.apiPermissions + '/user/' + encodeURI(email);
            var type = 'get';
            var data = null;

            httpService.asyncCall(url, type, data)
    			.then(function(response) {
    				for(var i = 0; i < response.data.length; i++) {
                    	$scope.permissionChecks[response.data[i].permissionDisplayName] = true;
                    }

    			}).catch(function(e){

				});

    		$scope.permissionsWindow.center().open();
        };

    	/**
         * Prepares the http request for updating a user. Handles callbacks.
         *
         * @function
         * @param { obj } user - user object
         */
        $scope.updateUser = function(user) {
        	var url = __env.apiBaseUrlUser  + 'users/' + user.userId;
    		var type = 'put';
			user.email = user.email.toLowerCase();
    		var data = user;

    		httpService.asyncCall(url, type, data)
    			.then(function(response) {
    				toastr.success('User successfully updated');
    				$scope.userGrid.dataSource.read();
    			}).catch(function(e){
    				toastr.error('The User could not be updated');
                     var message = 'Status: ' + e.status +
                                    '; Error:' + e.statusText;

                    $log.error(message);
    				$scope.userGrid.dataSource.read();
    			});

		};

        $scope.init = function() {
        	// load all permissions on page load to populate modal
        	$scope.getPermissions();
        };

    	$scope.init();
	};
})();
